import { Grid, Typography } from '@material-ui/core';
import { graphql } from 'gatsby';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Helmet from 'react-helmet';
import Intro from '../components/Intro/IntroSubPages';
import ProductComponent from '../components/Products/Product';
import theme from '../theme';
import Container from '../components/Container';

export const query = graphql`
  query Category {
    strapiProduct: allStrapiProduct(filter: { status: { eq: "published" } }) {
      edges {
        node {
          slug
          title
          description
          price
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 150)
              }
            }
          }
          Custom_field {
            id
            title
            required
            options
          }
        }
      }
    }
  }
`;

const useStyles = makeStyles({
  wrapper: {
    overflow: 'hidden',
    backgroundColor: '#F9F9F9',
    padding: '5rem',
  },
  intro: {
    height: '25vh',
    maxHeight: 250,
    position: 'relative',
    overflow: 'hidden',
    '& .background-image-wrapper': {
      maxHeight: '100%',
      '& .background-image': {
        width: '100%',
        maxHeight: '100%',
      },
    },
  },
  product: {
    // padding: '1rem',
  },
  title: {
    color: '#000000DE',
    fontWeight: 'bold',
    marginBottom: '5rem',
  },
  highlighted: {
    backgroundColor: '#5841D8',
    color: '#fff',
    padding: theme.spacing(2),
  },
});

const Products = ({ data }) => {
  const classes = useStyles();
  const products = data.strapiProduct.edges;
  const sortedProducts = products.sort((card_1, card_2) =>
    card_1.node.price > card_2.node.price ? 1 : -1
  );
  return (
    <ThemeProvider theme={theme}>
      <SEO title="Meetrix.IO | Products" description={'Meetrix Products'} />
      <Helmet>
        {/* Global site tag (gtag.js) - Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=UA-118777783-1"
        ></script>
        <script type="text/javascript">
          {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-118777783-1');`}
        </script>
        {/* <!-- Google Tag Manager --> */}
      <script type="text/javascript">{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N8NWRND');
      `}</script>
      {/* <!-- End Google Tag Manager --> */}
      {/* <!-- Google tag (gtag.js) --> */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-20D2B15V4Y"></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-20D2B15V4Y');`}
      </script>
      </Helmet>
      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N8NWRND"
      height="0" width="0" style={{display:'none', visibility:'hidden' }}></iframe></noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
      <Layout pageName={'Products'}>
        {/* <Intro headingCenter="Meetrix Marketplace" customStyles={classes.intro}/> */}
        <div className={classes.highlighted}>
          <Container>
            Save over 90% of cost compared to manual deployment
          </Container>
        </div>
        <div className={classes.wrapper}>
          <Typography variant="h4" className={classes.title}>
            Launch and Manage Your PaaS Infrastructure as Code
          </Typography>
          <Grid container spacing={3}>
            {sortedProducts.map(({ node }) => {
              const { title, description, price, image, slug, Custom_field } =
                node;

              return (
                <Grid item xs={12} sm={4} lg={3} className={classes.product}>
                  <ProductComponent
                    title={title}
                    description={description}
                    price={price}
                    gatsbyImageData={
                      image.localFile.childImageSharp.gatsbyImageData
                    }
                    slug={slug}
                    awsLink={
                      Custom_field[4].options !== 'none'
                        ? Custom_field[4].options
                        : ''
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Layout>
    </ThemeProvider>
  );
};

export default Products;
